import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../../lib';


const formName = 'Braille/ADA Signs';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Content': '',
  'Material': '',
  'Colour-sequence': '',
  'Match-existing-signage': '',
  'Braille-required': '',
  'Applique-required': '',
  'Installation-required': '',
};

const fields = [
  'Quantity',
  'Size',
  'Content',
  'Material',
  'Colour-sequence',
  'Match-existing-signage',
  'Braille-required',
  'Applique-required',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <Textarea
        textareaId='Content'
        textareaName='Content'
        register={register}
        formState={formState}
        label='Content'
        theme={textareaTheme}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='Material?'
        options={[
          { value: 'acrylic', label: 'Acrylic' },
          { value: 'metal', label: 'Metal' },
          { value: 'lamacoid', label: 'Lamacoid' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Colour-sequence'
        inputTextName='Colour-sequence'
        register={register}
        formState={formState}
        label='Colour-sequence'
        theme={inputTheme}
      />

      <Radio
        radioId='Match-existing-signage'
        radioName='Match-existing-signage'
        legend='Are we matching existing signage?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Braille-required'
        radioName='Braille-required'
        legend='Braille required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Applique-required'
        radioName='Applique-required'
        legend='Applique required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Installation required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
